import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typeahead from './../typeahead/typeahead';
import styles from './header.css';
import awardsLogo from './../../images/logo_awards.svg';
import { Link } from 'gatsby';

export default class Header extends Component {
  static propTypes = {
    search: PropTypes.string,
    parent: PropTypes.string,
    displaySearchSuggestions: PropTypes.bool,
    searchData: PropTypes.array.isRequired,
    onSearchChange: PropTypes.func.isRequired
  };
  render() {
    const { parent, search, searchData, onSearchChange, displaySearchSuggestions } = this.props;
    return (
      <div className={`pure-g ${styles.header}`}>
        <div className={`${styles.logoWrapper} pure-u-1 pure-u-md-2-3 u-c`}>
          <Link to="/" aria-label="Speedtest Awards">
            <svg className={styles.logo} viewBox={'0 0 395 30'} dangerouslySetInnerHTML={{ __html: awardsLogo }} />
          </Link>
        </div>
        <div className={`${styles.searchWrapper} pure-u-1 pure-u-md-1-3 u-c`}>
          <Typeahead
            displaySuggestions={displaySearchSuggestions}
            parent={parent}
            data={searchData}
            search={search}
            onSearchChange={onSearchChange}
          />
        </div>
      </div>
    );
  }
}
